<template>
  <div
    class="playlist-card d-flex flex-column flex-md-row p-3 img-container"
    :class="{ review: review }"
    v-bind="$attrs"
    @click="redirectToPlaylistDetail()"
  >
    <div class="d-flex flex-wrap p-0 col-lg-4 col-md-4 col-12">
      <HMFixedAspectRatioContainer class="mb-3">
        <PlaylistStudentThumbnail
          :playlist="playlist"
          :showListIcon="true"
          :showPlayIcon="true"
        />
      </HMFixedAspectRatioContainer>
    </div>
    <div class="flex-1">
      <div class="d-flex flex-column ms-3">
        <div
          class="order-md-3 order-lg-3 order-sm-1 playlist__tag smallest me-2 font-weight-bold"
        >
          <HMTag class="me-2 text-dark bg-light-gray">
            {{ getMediaCountText }}
          </HMTag>
          <HMTag class="me-2 text-dark bg-light-gray">
            <StudioPlaylistMediaTag
              :playlist="playlist"
            ></StudioPlaylistMediaTag>
          </HMTag>
        </div>
        <h4 class="order-md-1 order-lg-1 order-sm-2">
          {{ playlist.playlist_name }}
        </h4>
        <div class="smaller mb-3 order-md-2 order-lg-2 order-sm-3">
          {{ formatDate(playlist.updated) }}
        </div>
        <div class="d-flex order-4">
          <HMInstructorsStack :instructors="instructors" size="28px" />
          <span v-if="instructors.length" class="ms-2 c-charcoal py-1">{{
            $t('PRODUCTS.LABELS.INSTRUCTORS_VARIANT', {
              cnt: instructors.length,
            }, instructors.length)
          }}</span>
        </div>
      </div>
    </div>
    <div>
      <HMButton class="playlist__view-button d-none d-md-block" color="brand">
        <i class="fas fa-play me-2"></i>
        {{ $t('PRODUCTS.BUTTON.VIEW_PLAYLIST') }}
      </HMButton>
    </div>
  </div>
</template>
<script lang="ts">
import moment from '@/services/moment';
import PlaylistStudentThumbnail from '@/components/playlists/PlaylistStudentThumbnail.vue';
import StudioPlaylistMediaTag from '@/components/shop/StudioPlaylistMediaTag.vue';

export default {
  name: 'PlaylistStudentItemCard',
  props: {
    playlist: {
      type: Object as () => PlaylistResponse,
      required: true,
    },
    review: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PlaylistStudentThumbnail,
    StudioPlaylistMediaTag,
  },
  computed: {
    instructors() {
      const instructorsMap = new Map();
      this.playlist.content.forEach(item => {
        if (item.instructor) {
          instructorsMap.set(item.instructor.id, item.instructor);
        }
      });
      return [...instructorsMap.values()];
    },
    getMediaCountText() {
      return `${this.playlist.content.length}
				${this.$t('PRODUCTS.TEXT.ITEMS_VARIANT', this.playlist.content.length)}`;
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('MMM DD, yyyy');
    },
    redirectToPlaylistDetail() {
      this.$router.push({
        name: 'studio-playlist',
        params: {
          product_id: this.$route.params.product_id,
          playlist_id: this.playlist.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';
.playlist-card {
  cursor: pointer;
  @include media-breakpoint-down(sm) {
    padding: 0 !important;
  }
  @include media-breakpoint-up(md) {
    border: 1px solid #e3e7ec;
    border-radius: 6px;
  }
}

.playlist__view-button {
  // position: absolute;
  // right: 15px;
  // top: 15px;
}

.playlist__tag {
  margin-bottom: 30px;

  @include media-breakpoint-down(sm) {
    margin-bottom: 10px;
  }
}

.img-container {
  @include media-breakpoint-down(sm) {
    margin-left: -1rem;
    margin-right: -1rem;
  }
}

.bg-light-gray {
  background-color: $light-gray;
}

.review {
  pointer-events: none;
}
</style>
